import { ContentChefClient } from "@contentchef/contentchef-management-js-client";
import { ContentRepositoryResponse, Release, ReleaseId, ReleaseItem } from "@contentchef/contentchef-types";
import { IObservableArray } from "mobx";

export interface PublishToLiveStoreModel {
  api: ContentChefClient;
  releaseId: ReleaseId | null;
  release: Release | null;
  releaseItems: ReleaseItemWithRepository[];
  releaseItemsToPromote: IObservableArray<ReleaseItem>;
  filteredReleaseItems: ReleaseItemWithRepository[];
  loaders: Loaders;
  init(): void;
  addReleaseItem(releaseItem: ReleaseItem): void;
  removeReleaseItem(releaseItem: ReleaseItem): void;
  publishToLive(skipLinkedContentValidation?: boolean): Promise<boolean>;
  isReleaseItemSelected(releaseItem: ReleaseItem): boolean;
  selectAllItems(): void;
  filterReleaseItems(searchValue?: string): void;
}

export interface ReleaseItemWithRepository extends ReleaseItem {
  repository: ContentRepositoryResponse;
}

interface Loaders {
  [key: string]: boolean;
}

export interface UnresolvedLink {
  sourcePublicId: string;
  sourceContentId: number;
  sourceContentLocale: string;
  linkedPublicId: string;
}

export interface StageToLiveUnresolvedLinks {
  type: string;
  details: {
    type: string;
    message: string;
    unresolvedLinks: UnresolvedLink[];
  };
}

export function isStageToLiveCountMismatch(error: any): boolean {
  return error != null && error.type === "StageToLiveCountMismatch";
}

export function isStageToLiveUnresolvedLinks(error: any): error is StageToLiveUnresolvedLinks {
  return (
    error != null &&
    error.details != null &&
    Array.isArray(error.details.unresolvedLinks) &&
    error.details.unresolvedLinks.length > 0
  );
}
